<template>
  <div class="rt-table-list">
    <div class="header">
      <div class="warp-title">
        <img src="@/assets/img/icon17.png" style="width: 20px; margin-right: 5px;"/>
        场内车辆
      </div>
      <div class="realtime-table-header">
        <el-input
          class="item34"
          placeholder="搜索车牌"
          v-model="searchStr"
          style="width: 120px;"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" style="color: #5E7FEC;" @click="server"></i>
        </el-input>
        <el-button type="primary" @click="server" style="margin-left: 10px;">
          <img src="@/assets/img/icon01.png" style="width: 14px; margin-right: 5px;"/>
          刷新
        </el-button>
        <el-button type="primary" @click="handleShowDrawer">
          <el-badge is-dot class="item" :hidden="hasNotMorePup">
            <img src="@/assets/img/icon05.png" style="width: 14px; margin-right: 5px;"/>
            出入场弹框
          </el-badge>
        </el-button>
      </div>
    </div>
    <el-table
      highlight-current-row
      ref="table"
      @row-contextmenu="rightMenu"
      row-class-name="table-item"
      :cell-class-name="tableCellStyle"
      :row-style="{height:0+'px'}"
      :data="data"
      :height="233"
      style="width: 100%"
    >
      <el-table-column prop="passInPlateImage" label="凭证" align="center" width="100">
        <template slot-scope="scope">
          <el-image
            class="img"
            lazy
            :src="scope.row.passPlateImage"
            fit="fill"
            :preview-src-list="scope.row.passPlateImageArr"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              暂无图片
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="plateNumber" label="车牌" align="center"  width="120">
        <template slot-scope="scope">
          <p v-if="!isEditPlateNumber" style="font-size: 16px; font-weight: bold;">{{ scope.row.plateNumber }}</p>
          <plate-input
            v-else
            :data.sync="scope.row.editNumber"
            :visible.sync="scope.row.isEdit"
            @ok="confirmEditNumber"
          >
            <div>
              <p v-if="!scope.row.isEdit" style="font-size: 16px; font-weight: bold;">
                {{ scope.row.plateNumber }}
              </p>
              <el-input
                size="mini"
                :autofocus="true"
                v-else-if="currentRow === scope.row && scope.row.isEdit"
                v-model="scope.row.editNumber"
              />
            </div>
          </plate-input>
        </template>
      </el-table-column>
      <el-table-column label="车类" show-overflow-tooltip align="center" width="80">
        <template slot-scope="scope">
          <span :style="{color: scope.row.carTypeStr === '月卡车' ? '#5E7FEC' : '#606266'}">{{scope.row.carTypeStr}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="carSize" label="车型" align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isEditCarSize">{{showCarSizeTable(scope.row.carSize)}}</div>
          <el-select v-model="scope.row.carSize" placeholder="请选择" v-else @change="handleCarSize">
            <el-option
              v-for="(item, index) in carSizeTable"
              :key="index"
              :value="item.Id"
              :label="item.Name"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="cameAt" label="入场时间" align="center" show-overflow-tooltip></el-table-column>
    </el-table>
    <page-size ref="page" @pageChange="server" />
    <rightMenu ref="menu" @onClick="onClick"></rightMenu>
    <dialog-handle-table-out
      v-if="showHandleTableOut"
      :showdialog.sync="showHandleTableOut"
      @getOutGateId="confirmOpenGate"
    ></dialog-handle-table-out>
    <dialog-handle-order-qr
      v-if="showHandleOrderQr"
      :showdialog.sync="showHandleOrderQr"
      title="订单二维码"
      :parkingName="currentRow.parkingName"
      :plateNumber="currentRow.plateNumber"
      :orderNo="currentRow.orderNo"
      :cameAt="currentRow.cameAt"
      :orderId="currentRow.id"
      :tId="currentRow.tenantId"
      :parkLotId="currentRow.parkLotId"
    ></dialog-handle-order-qr>
    <el-dialog
      :title="titleEditOrder"
      :visible.sync="showEditOrder"
      width="500px"
      center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="总金额" prop="payableAmount">
          <el-input clearable v-model="ruleForm.payableAmount"></el-input>
        </el-form-item>
        <el-form-item label="已支付金额" prop="moneyValuePaid">
          <el-input clearable v-model="ruleForm.moneyValuePaid"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="updateRemark">
          <el-input
            type="textarea"
            clearable
            placeholder="请输入备注"
            v-model="ruleForm.updateRemark"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditOrder = false">取 消</el-button>
        <el-button type="primary" @click="handleCarAmount">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import plateInput from "@/components/PlateInput/index";
import pageSize from "@/components/PageSize/index";
import rightMenu from "@/components/rightMenu/index";
import { queryParkOrder, updateOrder, billCarSize, getOrder } from "@/api/module/tenant";
import parkMix from "@/minxs/parkLotId";
import showdialog from "@/minxs/showdialog";

import {
  orderPubSub,
  eventPubSub,
  parkInPubSub,
  parkOutPubSub,
} from "@/service/pubsub/index";

import { carPass, clearParkingCar } from "@/api/module/park";
import { getUserId } from "@/utils/service";

//手动出场选出口弹窗
import dialogHandleTableOut from "@/serviceComponents/dialogHandleTableOut";
import dialogHandleOrderQr from "@/serviceComponents/dialogHandleOrderQr";

export default {
  props: {
    height: {
      type: Number,
      default: 0,
    }
  },
  components: {
    plateInput,
    pageSize,
    rightMenu,
    dialogHandleTableOut,
    dialogHandleOrderQr,
  },
  data() {
    var validateNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入金额'));
      } else if (!/^(?:[1-9]\d{0,3}|0)(?:\.\d{1,2})?$/.test(value)) {
        callback(new Error('请输入0~9999.99的数字，最多两位小数'));
      } else {
        callback();
      }
    };
    return {
      searchStr: "",
      currentRow: null,
      isEditPlateNumber: false,
      data: [],
      currentIndex: 0,
      isEditCarSize: false,
      showHandleTableOut: false,
      showHandleOrderQr: false,
      hasNotMorePup: true,
      showEditOrder: false,
      titleEditOrder: '修改订单金额',
      ruleForm: {
        id: undefined,
        payableAmount: undefined,
        moneyValuePaid: undefined,
        updateRemark: undefined,
      },
      rules: {
        payableAmount: [
          { validator: validateNum, trigger: 'blur' }
        ],
        moneyValuePaid: [
          { validator: validateNum, trigger: 'blur' }
        ],
        updateRemark: [
          { required: false, message: '请填写备注', trigger: 'blur' }
        ]
      },
    };
  },
  mixins: [parkMix, showdialog],
  watch: {
    $route: {
      handler: function(){
        this.server();
        this.getCarSize();
        this.checkNotMorePup();
      },
      deep: true
    },
    showOrderInfo: 'checkNotMorePup',
  },
  mounted() {
    this.server();
    this.getCarSize();
    this.$nextTick(() => {
      eventPubSub.unsubscribe();
      eventPubSub.subscribe(this.server);
      parkInPubSub.unsubscribe();
      parkInPubSub.subscribe(this.server);
      parkOutPubSub.unsubscribe();
      parkOutPubSub.subscribe(this.server);
    });
  },
  computed: {
    wsOrderArr: function () {
      return this.$store.state.order.moreWsData[this.$route.params.GateId];
    },
    tabGateId: function () {
      return this.$store.state.order.payOrderGateId;
    },
    leftGateTab: {
      get() {
        return JSON.parse(this.$store.state.order.leftGateIdTabs);
      },
    },
    showOrderInfo: {
      get () {
        return this.$store.state.order.showOrderDetail || false
      },
      set (value) {
        this.$store.dispatch('GetShowOrderDetail', value)
      }
    },
    showPassInStr: function () {
      return JSON.parse(this.$store.state.layout.showPassInStr);
    },
  },
  methods: {
    async server() {
      const $page = this.$refs.page;
      let res = await queryParkOrder({
        Page: $page ? $page.current : 1,
        PerPage: $page ? $page.pageSize : 5,
        ParkLotId: this.ParkLotId,
        orderNo: "",
        PlateNumber: this.searchStr,
        orderType: "正常",
        IsLimitDate: 1,
        Isleft: 2,
        GateQuery: true,
      });
      if (res.state === "success") {
        let data = res.data;
        data.forEach((item, index) => {
          item.isEdit = false;
          item.isEditCarSize = false;
          item.editNumber = "";
          item.Index = index;
          item.carSize = item.carSize > 0 ? item.carSize : 1;
          item.passPlateImage = item.passInPlateImage === '' ? item.passOutPlateImage : item.passInPlateImage;
          item.passPlateImageArr = [item.passPlateImage];
        });
        this.data = data;
        this.currentRow = this.data[0];
        if ($page) $page.total = res.pageInfo.Total;
      } else {
        this.data = [];
        if ($page) $page.total = 0;
      }
    },
    refresh() {
      this.searchStr = "";
      this.server();
    },
    // 编辑修改车牌
    editPlateNumber() {
      this.isEditPlateNumber = !this.isEditPlateNumber;
      this.filterData();
    },
    getRow(row, column) {
      console.log(row, column);
    },
    filterData() {
      this.data.forEach((item) => {
        item.editNumber = item.plateNumber;
        item.isEdit = false;
        item.isEditCarSize = false;
      });
    },
    checkRow(row) {
      orderPubSub.publish(row);
      // this.$refs.table.setCurrentRow(row);
    },
    toggleRowSelection(row) {
      this.currentRow = row;
      orderPubSub.publish(this.currentRow);
      this.$refs.table.setCurrentRow(row);
      this.$store.dispatch("GetShowOrderDetail", true);
      let $menu = this.$refs.menu;
      $menu.rightMenu.close();
      this.filterData();
    },
    startEditPlateNumber(row) {
      row.isEdit = true;
      row.editNumber = row.plateNumber;
    },
    async confirmEditNumber(obj) {
      // console.log("车牌信息", obj);
      let param = {
        id: this.currentRow.id,
        // payableAmount: Number(this.currentRow.payableAmount),
        // moneyValuePaid: Number(this.currentRow.moneyValuePaid),
        status: this.currentRow.status,
        plateColor: this.currentRow.plateColor,
        plateNumber: this.currentRow.plateNumber,
        carSize: this.currentRow.carSize,
        Source: 2,
        LoginPlatform: 'gate',
      };
      if (Object.keys(obj).length === 4) {
        param.payableAmount = Number(this.ruleForm.payableAmount);
        param.moneyValuePaid = Number(this.ruleForm.moneyValuePaid);
        param.updateRemark = this.ruleForm.updateRemark;
      } else {
        param[obj.key] = obj.value;
      }
      let res = await updateOrder(param);
      if (res.state === "success") {
        this.server();
        this.currentRow.isEdit = false;
        this.showEditOrder = false;
      } else {
        this.$message.error(res.message);
      }
    },
    rightMenu() {
      this.currentRow = arguments[0];
      arguments[2].preventDefault();
      let $menu = this.$refs.menu;
      $menu.rightMenu.open(arguments[2]);
      this.isEditPlateNumber = true;
      // this.currentRow(this.currentRow);
      this.filterData();
    },
    onClick(key) {
      switch (key) {
        case "手动出场":
          if (this.leftGateTab.length > 1){
            this.showHandleTableOut = true
          } else {
            carPass({
              ParkLotId: this.currentRow.parkLotId,
              ParkLotGateId: this.leftGateTab[0].Id,
              PlateNumber: this.currentRow.plateNumber,
              PlateColor: this.currentRow.plateColor,
              Direction: 2,
              WaitTime: this.formatDateTime(new Date()),
              TenantUserId: parseInt(getUserId())
            })
          }
          break;
        case "修改车牌":
          this.getOrder(this.currentRow.id, key);
          this.startEditPlateNumber(this.currentRow);
          break;
        case "修改车型":
          // console.log(this.currentRow);
          this.getOrder(this.currentRow.id, key);
          // this.isEditCarSize = true;
          // this.startEditCarSize(this.currentRow);
          break;
        case "修改订单金额":
          this.getOrder(this.currentRow.id, key);
          // console.log(this.currentRow);
          // this.ruleForm.id = this.currentRow.id;
          // this.ruleForm.payableAmount = this.currentRow.payableAmount;
          // this.ruleForm.moneyValuePaid = this.currentRow.moneyValuePaid;
          // this.ruleForm.updateRemark = this.currentRow.updateRemark;
          // this.titleEditOrder = this.currentRow.plateNumber + this.titleEditOrder;
          // this.showEditOrder = true;
          // this.startEditCarSize(this.currentRow);
          break;
        case "清除不在场车辆":
          this.$confirm("确认该车辆不在场内，要结束该订单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.clearParkingCar();
          });
          break;
        case "显示订单二维码":
          console.log(this.currentRow);
          this.showHandleOrderQr = true;
          break;
      }
    },
    startEditCarSize(row) {
      row.isEditCarSize = true;
    },
    handleCarSize() {
      this.confirmEditNumber({value: this.currentRow.carSize, key: 'carSize'})
    },
    async getCarSize() {
      let res = await billCarSize();
      if (res.state === "success") {
        this.carSizeTable = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    handleCarAmount() {
      this.confirmEditNumber(this.ruleForm)
    },
    async confirmOpenGate(str) {
      // console.log(str, this.currentRow);
      // this.$store.dispatch("GetShowOrderDetail", true);
      // this.$nextTick(() => {
      //   this.checkRow({Id: this.currentRow.id, order_id: this.currentRow.id, park_lot_gate_id: str, isWs: false});
      // })
      let res = await carPass({
        ParkLotId: this.currentRow.parkLotId,
        ParkLotGateId: parseInt(str),
        PlateNumber: this.currentRow.plateNumber,
        PlateColor: this.currentRow.plateColor,
        Direction: 2,
        WaitTime: this.formatDateTime(new Date()),
        TenantUserId: parseInt(getUserId())
      });
      if (res.state === "success") {
        this.server();
      } else {
        this.$message.error(res.message);
      }
    },
    handleShowDrawer() {
      let arr = this.wsOrderArr.filter(v => { return !v.isPaid && this.tabGateId === parseInt(v.park_lot_gate_id)});
      // console.log('handleShowDrawer', arr[0]);
      if (this.leftGateTab.length > 0) {
        if (!this.tabGateId){
          this.$store.dispatch("SetPayOrderGateId", this.leftGateTab[0].Id);
          this.$store.dispatch("SetTabsGateId", this.leftGateTab[0].Id);
        }
        this.$store.dispatch("GetShowOrderDetail", true);
        this.$nextTick(() => {
          if (arr.length > 0) {
            arr[0].otherMsg = undefined;
            orderPubSub.publish(arr[0]);
          } else {
            orderPubSub.publish({Id: -1});
          }
        })
      } else {
        this.$message({
          message: "没有出口",
          type: "error",
        });
      }
    },
    getCarSizeItem(obj) {
      console.log('getCarSizeItem', obj)
    },
    async clearParkingCar() {
      // console.log(this.currentRow);
      let res = await clearParkingCar({
        id: this.currentRow.id,
        payableAmount: this.currentRow.payableAmount,
        moneyValuePaid: this.currentRow.moneyValuePaid,
        plateColor: this.currentRow.plateColor,
        plateNumber: this.currentRow.plateNumber,
        carSize: this.currentRow.carSize,
        status: 1,
        Source: 2,
      });
      if (res.state === "success") {
        this.server();
      } else {
        this.$message.error(res.message);
      }
    },
    tableCellStyle({row, columnIndex}) {
      if(columnIndex === 0){
        return 'imgCell ' + this.array[row.plateColor - 1]
      }
    },
    checkNotMorePup() {
      let moreBlackParkIn = this.$store.state.order.moreBlackParkIn.lastKey ? this.$store.state.order.moreBlackParkIn[this.$route.params.GateId] : [];
      moreBlackParkIn = this.showPassInStr[this.$route.params.GateId] ? moreBlackParkIn.filter(v => {return v.message_type !== '5' && v.message_type !== '32' }) : [];
      this.hasNotMorePup = moreBlackParkIn.length === 0 && this.wsOrderArr.length === 0;
      // console.log('checkNotMorePup', this.hasNotMorePup)
    },
    async getOrder(id, key) {
      let res = await getOrder({id});
      if (res.state === "success") {
        console.log(key)
        this.currentRow = res.data;
        switch (key) {
          case "修改车牌":
            this.startEditPlateNumber(this.currentRow);
            break;
          case "修改车型":
            // console.log(this.currentRow);
            this.isEditCarSize = true;
            this.startEditCarSize(this.currentRow);
            break;
          case "修改订单金额":
            this.ruleForm.id = this.currentRow.id;
            this.ruleForm.payableAmount = this.currentRow.payableAmount;
            this.ruleForm.moneyValuePaid = this.currentRow.moneyValuePaid;
            this.ruleForm.updateRemark = this.currentRow.updateRemark;
            this.titleEditOrder = this.currentRow.plateNumber + this.titleEditOrder;
            this.showEditOrder = true;
            break;
        }
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.realtime-table-header{
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
  & > span:first-child {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    opacity: 1;
    & > i {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      opacity: 1;
      cursor: pointer;
    }
  }
  & > span:last-child {
    font-size: 16px;
    color: #0178ec;
    opacity: 1;
    cursor: pointer;
    display: inline-block;
    width: 100px;
  }
}
</style>
<style lang="scss">
.table-item {
  cursor: pointer;
}
</style>
